import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import useAuth from "../../Auth/useAuth";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import './Business.css';
import AlertModal from '../AlertModal/AlertModal'
import config from '../../config';

axios.defaults.baseURL = config.BASE_URL;


const Business = () => {

  const { setTripIDState, moduleChange, setModuleChange,activeModule,setActiveModule } = useAuth();
  const Navigate = useNavigate();
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    vendor: '',
    truckNumber: ''
  });

  const [truckNumbers, setTruckNumbers] = useState([]);
  const [truckQuery, setTruckQuery] = useState('');
  const [showTruckDropdown, setShowTruckDropdown] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [destinations, setDestinations] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  // Add modal state
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info'
  });

    // Modal handler functions
  const showModal = (title, message, type = 'info') => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      type
    });
  };

  const closeModal = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  };

  let grandTotal = 0;


  useEffect(()=>{
    sessionStorage.setItem('actMod', 'business');
    setActiveModule(sessionStorage.getItem('actMod'));

  },[]);

  const handleDownload = async (id, field, originalname) => {

    try {
      const response = await axios.get(`/api/download/${id}/${field}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },

          responseType: 'blob' // Important: This tells axios to handle the response as a binary blob
        });

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      // Create a download link and trigger it
      saveAs(blob, originalname || 'download');

    } catch (error) {
      console.error('Download error:', error);
      showModal('Download Error', 'Error downloading file. Please try again.', 'error');
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {

      // Close truck dropdown if click is outside
      if (showTruckDropdown && !event.target.closest('.d2')) {
        setShowTruckDropdown(false);
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTruckDropdown]);


  useEffect(() => {
    // Fetch truck numbers for dropdowns
    fetchTruckNumbers();
  }, []);


  const fetchTruckNumbers = async () => {
    try {
      const response = await axios.get('/api/trucks',
        {
          withCredentials: true,
          headers: {
              "Content-Type": "application/json",
          }
        }
      );

      setTruckNumbers(response.data.truckData);
      console.log(truckNumbers);

    } catch (error) {

      console.error('Error fetching truck numbers:', error);

    }
  };

  const filteredTrucks = truckNumbers.filter((truck) =>
    truck.truck_no.toLowerCase().includes(truckQuery.toLowerCase())
  );



  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const fetchDestinationData = async () => {
    try {
      const response = await axios.get('/api/destination',
        {
          withCredentials: true,
          headers: {
              "Content-Type": "application/json",
          }
        }
      );

      setDestinations(response.data.destinationData);

    } catch (error) {
      console.error('Error fetching destination data:', error);
    }
  }

  useEffect(() => {
    fetchDestinationData();
    console.log("destinations: ", destinations);

  }, []);

  const calculateTotal = (row, rate) => {
    // const currentRecord = destinations.filter(destination => 
    //         destination.from.toLowerCase() === row.toLowerCase() &&
    //         destination.to.toLowerCase() === row.toLowerCase()
    //     )

    const freight = parseFloat(row.Freight) || 0;
    const TDS_val = parseFloat(row.TDS_Rate) || 0;
    const short = parseFloat(row.Short) || 0;
    const differenceInWeight = parseFloat(row.DifferenceInWeight) || 0;
    const dieselAmount = parseFloat(row.DieselAmount) || 0;
    const advance = parseFloat(row.Advance) || 0;
    const toll = parseFloat(row.Toll) || 0;
    const adblue = parseFloat(row.Adblue) || 0;
    const greasing = parseFloat(row.Greasing) || 0;

    grandTotal += (Number(Math.round(freight - ((freight * TDS_val) / 100) - short - dieselAmount - advance - toll - adblue - greasing)));

    return Number(Math.round(freight - ((freight * TDS_val) / 100) - short - dieselAmount - advance - toll - adblue - greasing));
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    setShowTruckDropdown(false);
    setIsLoading(true);

    grandTotal = 0; // Reset grand total for each search

    console.log('filters: ', filters);
    if (!(filters.startDate && filters.endDate) && !filters.truckNumber) {
      setIsLoading(false);
      showModal('Filter Error', 'Please select at least one filter', 'error');
      return;
    }

    if (((filters.startDate && !filters.endDate) || (!filters.startDate && filters.endDate)) && filters.truckNumber) {
      setIsLoading(false);
      showModal('Filter Error', 'Please select both start-date and end-date', 'error');
      return;
    }

    // if((filters.startDate && filters.endDate) && !filters.truckNumber){
    //     showModal('Filter Error', 'Please select a truck number', 'error');
    //     return;
    // }

    try {
      const response = await axios.get('/api/reports', { 
          params: filters, 
          withCredentials: true,
          headers: {
              "Content-Type": "application/json",
          }
        }
      );

      console.log('table data :', response?.data?.tableData);

      //changes made that to made in deployed branch
      // const sortedData = response?.data?.tableData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      // console.log('Sorted table data: ', sortedData);
      setTableData(response?.data?.tableData);
      setIsLoading(false);
      //till here


      if (response?.data?.tableData?.length === 0) {
        showModal('No Records', 'No records available for the selected filters.', 'info');
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response?.data?.message) {
        showModal('Error', error.response?.data?.message, 'error');
      } else {
        showModal('Error', 'Error fetching Table data. Please try again.', 'error');
      }
      console.error('Error fetching reports:', error);
    }
  };

  const formatTime = (time) =>{
    const [timePart, ampm] = time.split(' ');
    const [hour,minutes] = timePart.split(':');

    let formattedTime = `${hour}:${minutes} ${ampm}`;
    
    return formattedTime;
  }


  const downloadExcel = () => {

    grandTotal = 0; // Reset grand total for each download
    const ExcelData = tableData.map(row => {

      const { DieselSlipImage, LoadingAdvice, InvoiceCompany, WeightmentSlip, _id, TripID, Username, Profile, TruckNumber, DONumber, createdAt, updatedAt, __v, DriverName, Vendor, DestinationFrom, DestinationTo, TruckType, TransactionStatus, Weight, ActualWeight, DifferenceInWeight, Freight, DieselAmount, DieselSlipNumber, TDS_Rate, Short, Advance, Toll, Adblue, Greasing, BillId, localDate, localTime} = row;

      const destinationRate = destinations.find(
        dest => dest.from.toLowerCase() === row.DestinationFrom.toLowerCase() &&
          dest.to.toLowerCase() === row.DestinationTo.toLowerCase()
      )?.rate || 0;

  // Calculate the total WITHOUT modifying grandTotal
  const freight = parseFloat(row.Freight) || 0;
  const TDS_val = parseFloat(row.TDS_Rate) || 0;
  const short = parseFloat(row.Short) || 0;
  const dieselAmount = parseFloat(row.DieselAmount) || 0;
  const advance = parseFloat(row.Advance) || 0;
  const toll = parseFloat(row.Toll) || 0;
  const adblue = parseFloat(row.Adblue) || 0;
  const greasing = parseFloat(row.Greasing) || 0;

  const total = Number(Math.round(freight - ((freight * TDS_val) / 100) - short - dieselAmount - advance - toll - adblue - greasing));
  
      grandTotal += total;

      return {
        "Trip ID": TripID,
        "Username": Username,
        "Profile": Profile,
        "Truck Number": TruckNumber,
        "DO": DONumber,
        "Date": localDate,
        // "Time": formatTime(localTime),
        "Driver": DriverName,
        "Vendor": Vendor,
        "From": DestinationFrom,
        "To": DestinationTo,
        "Truck Type": TruckType,
        "Transaction": TransactionStatus,
        "Wt.": Weight,
        "A. Wt.": ActualWeight,
        "Diff. Wt.": DifferenceInWeight,
        "Freight": Freight,
        "Diesel": DieselAmount,
        "Dsl. Slp. No.": DieselSlipNumber,
        "TDS": (Freight * (TDS_Rate/100)).toFixed(2),
        "Short":Short,
        "Adv.": Advance,
        "Toll": Toll,
        "Adblue": Adblue,
        "Greasing": Greasing,
        "Bill ID": BillId,
        "Amount": total
      }
    });

    ExcelData.push({
      "Trip ID": '',
      "Username": '',
      "Profile": '',
      "Truck Number": '',
      "DO": '',
      "Date": '',
      // "Time": '',
      "Driver": '',
      "Vendor": '',
      "From": '',
      "To": '',
      "Truck Type": '',
      "Transaction": '',
      "Wt.": '',
      "A. Wt.": '',
      "Diff. Wt.": '',
      "Freight": '',
      "Diesel": '',
      "Dsl. Slp. No.": '',
      "TDS": '',
      "Short": '',
      "Adv.": '',
      "Toll": '',
      "Adblue": '',
      "Greasing": '',
      "Bill ID": '',
      "Amount": grandTotal
    });


    const worksheet = XLSX.utils.json_to_sheet(ExcelData);


    // Set column widths
    worksheet['!cols'] = [
      { wch: 10 },  // Trip ID
      { wch: 15 },  // Username
      { wch: 20 },  // Profile
      { wch: 12 },  // Truck Number
      { wch: 12 },  // DO Number
      { wch: 12 },  // Date
      // { wch: 10 },  // Time
      { wch: 15 },  // Driver Name
      { wch: 15 },  // Vendor
      { wch: 18 },  // Destination From
      { wch: 18 },  // Destination To
      { wch: 15 },  // Truck Type
      { wch: 20 },  // Transaction Status
      { wch: 10 },  // Weight
      { wch: 15 },  // Actual Weight
      { wch: 15 },  // Difference In Weight
      { wch: 15 },  // Freight
      { wch: 15 },  // Diesel Amount
      { wch: 15 },  // Diesel Slip Number
      { wch: 10 },  // TDS Rate
      { wch: 10 },  // Short
      { wch: 10 },  // Advance
      { wch: 10 },  // Toll
      { wch: 10 },  // Adblue
      { wch: 10 },  // Greasing
      { wch: 10 }   // Bill ID
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', cellStyles: true });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, 'Business.xlsx');
  };

  return (
    <div className="business-container">
      <AlertModal
        isOpen={modalConfig.isOpen}
        onClose={closeModal}
        title={modalConfig.title}
        message={modalConfig.message}
        type={modalConfig.type}
      />
      <div className="filter-box">
        <form onSubmit={handleSubmit}>
          <div className="filters-grid">
            <div className="filter-item">
              <label>Start Date</label>
              <input
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={handleFilterChange}
              />
            </div>

            <div className="filter-item">
              <label>End Date</label>
              <input
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={handleFilterChange}
              />
            </div>

            <div className="filter-item d2">
              <label>Truck Number</label>
              <input
                type="text"
                name="truckNumber"
                autoComplete="off"
                value={(truckQuery).toUpperCase()}
                onChange={(e) => {
                  setTruckQuery(e.target.value);
                  handleFilterChange(e);

                }}
                onClick={() => setShowTruckDropdown(true)}
                placeholder="Search Truck"
              />
              {showTruckDropdown && (
                <ul className="dropdown">
                  {filteredTrucks.map((truck) => (
                    <li
                      key={truck._id}
                      onClick={() => {
                        setFilters({ ...filters, truckNumber: truck.truck_no });
                        setTruckQuery(truck.truck_no);
                        setShowTruckDropdown(false);
                      }}
                      style={{
                        padding: '5px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #ddd',
                      }}
                    >
                      {truck.truck_no}
                    </li>
                  ))}
                  {filteredTrucks.length === 0 && (
                    <li style={{ padding: '5px' }}>No trucks found</li>
                  )}
                </ul>
              )}
            </div>
          </div>

          <div className="button-group">
            <button type="submit" className="search-btn">Search</button>
            {/* <button type="button" className="today-list-btn" onClick={todayList}>Today's List</button> */}
            {tableData.length > 0
              && (
                <button type="button" className="download-btn" onClick={downloadExcel}>
                  Download Excel
                </button>
              )}
          </div>
        </form>
      </div>

      {isLoading && (
        <div className='table-wrapper'>
          <div className='spinner-container'>
            <div className='spinner'></div>
            <p>Loading business data...</p>
          </div>
        </div>
      )}

      {!isLoading && tableData.length > 0 && (
        <div className="table-box">
          <div className="table-responsive">
            <table>
              <thead id='headerRow'>
                <tr>
                  <th className='stickyColumnTH'>Trip ID</th>
                  <th>Username</th>
                  <th>Profile</th>
                  <th>Truck Number</th>
                  <th>DO</th>
                  <th>Date</th>
                  {/* <th>Time</th> */}
                  <th>Driver</th>
                  <th>Vendor</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Truck Type</th>
                  <th>Transaction</th>
                  <th>Wt.</th>
                  <th>A. Wt.</th>
                  <th>Diff. Wt.</th>
                  <th>Freight</th>
                  {/* <th>Diesel</th> */}
                  <th>Diesel</th>
                  <th>Dsl. Slp. No.</th>
                  <th>TDS</th>
                  <th>Short</th>
                  <th>Adv.</th>
                  <th>Toll</th>
                  <th>Adblue</th>
                  <th>Greasing</th>
                  <th>Bill Id</th>
                  <th>Amount</th>
                  <th>Diesel Slip</th>
                  <th>Loading Advice</th>
                  <th>Invoice Company</th>
                  <th>Weightment Slip</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map(row => {
                  const destinationRate = destinations.find(
                    dest => dest.from.toLowerCase() === row.DestinationFrom.toLowerCase() &&
                      dest.to.toLowerCase() === row.DestinationTo.toLowerCase()
                  )?.rate || 0;
                  return (
                    <tr key={row._id} className='table-row'>
                      <td
                        onClick={() => {
                          setModuleChange('/home');
                          setTripIDState(row);
                          Navigate(`/home/${row.TripID}`, { state: row })
                        }}
                        className='trip-id stickyColumnTD'

                      >{row.TripID}</td>
                      <td>{row.Username}</td>
                      <td>{row.Profile}</td>
                      <td>{row.TruckNumber}</td>
                      <td>{row.DONumber}</td>
                      <td>{row.localDate}</td>
                      {/* <td>{formatTime(row.localTime)}</td> */}
                      <td>{row.DriverName}</td>
                      <td>{row.Vendor}</td>
                      <td>{row.DestinationFrom}</td>
                      <td>{row.DestinationTo}</td>
                      <td>{row.TruckType}</td>
                      <td>{row.TransactionStatus}</td>
                      <td>{row.Weight}</td>
                      <td>{row.ActualWeight}</td>
                      <td>{row.DifferenceInWeight}</td>
                      <td>{row.Freight}</td>
                      {/* <td>{row.Diesel}</td> */}
                      <td>{row.DieselAmount}</td>
                      <td>{row.DieselSlipNumber}</td>
                      <td>{(row.Freight * (row.TDS_Rate/100)).toFixed(2)}</td>
                      <td>{row.Short}</td>
                      <td>{row.Advance}</td>
                      <td>{row.Toll}</td>
                      <td>{row.Adblue}</td>
                      <td>{row.Greasing}</td>
                      <td>{row.BillId}</td>
                      <td>{calculateTotal(row, destinationRate)}</td>
                      {['DieselSlipImage', 'LoadingAdvice', 'InvoiceCompany', 'WeightmentSlip'].map(field => (
                        <td key={field}>
                          {row[field]?.filepath ? (
                            <button
                              className="download-link-btn"
                              onClick={() => handleDownload(row._id, field, row[field].originalname)}
                            >
                              Download {row[field].originalname}
                            </button>
                          ) : (
                            'No file'
                          )}
                        </td>
                      ))}
                    </tr>
                  )
                })}
                <tr>
                  <td colSpan={25}></td>
                  <td style={{ fontWeight: 'bold', textAlign: 'left' }}>{grandTotal}</td>
                </tr>
              </tbody>


            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Business;